<script setup lang="ts">
import { ResultPage } from '@/functions/borrow/simulation/views';
import { ROUTES } from '@/enums';

import { definePageMeta, useSeoMeta, useHead } from '#imports';

useSeoMeta({
  title: '返済シミュレーション結果 | dスマホローン | カードがいらないドコモのカードローン',
  description:
    '返済シミュレーションの結果をご案内します。dスマホローンは、ドコモが提供するスマホ完結のローンサービスです。',
  keywords: 'dスマホローン,ドコモ,返済,シミュレーション',
  ogUrl: 'https://loan.docomo.ne.jp/borrow/simulation/result/',
  ogType: 'article',
  ogTitle: '返済シミュレーション結果 | dスマホローン | カードがいらないドコモのカードローン',
  ogDescription:
    '返済シミュレーションの結果をご案内します。dスマホローンは、ドコモが提供するスマホ完結のローンサービスです。',
  ogSiteName: 'dスマホローン | ドコモ',
  ogImage: 'https://loan.docomo.ne.jp/img/ogp.png',
});

useHead({
  link: [
    {
      rel: 'canonical',
      href: 'https://loan.docomo.ne.jp/borrow/simulation/result/',
    },
    {
      rel: 'icon',
      href: '/img/favicon.ico',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/img/android-chrome-192x192.png',
    },
    {
      rel: 'apple-touch-icon',
      href: '/img/apple-touch-icon.png',
    },
  ],
});

definePageMeta({
  ...ROUTES.BORROW_SIMULATION_RESULT.meta,
  layout: 'not-reset-template',
});
</script>

<template>
  <ResultPage />
</template>
